import {Stack, Typography, Button, Radio} from '@mui/material';
import {IconIllustration, CTAButtonFixed} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private';
import React, {useState} from 'react';
import {DOCUMENT_OPTIONS} from '../../constants';
import {FacialBiometricsHeader} from '../FacialBiometricsHeader';
import {ResponsiveCard} from '../ResponsiveCard';
import {Stepper} from '../Stepper';
import {RadioContainer} from './styles';
import {translations} from 'presentation/translations-new';
import {useFacialBiometricsStore} from 'presentation/modules/booking/shared/store/useFacialBiometricsStore';

const {description, primaryButton, title, errorMessage} =
	translations['pt-br'].others.facialBiometric.documentPhoto.documentSelection;

export function DocumentSelection({onSelect}: {onSelect: (value: string) => void}) {
	const {isTablet} = useMediaQueries();
	const [selectedOption, setSelectedOption] = useState<string>('');
	const [error, setError] = useState<boolean>(false);
	const {isUnder16, isTea} = useFacialBiometricsStore(state => state);

	const handleOptionChange = (value: string) => {
		setSelectedOption(value);
	};

	const handleNext = () => {
		if (!selectedOption) {
			setError(true);
			return;
		}

		setError(false);
		onSelect(selectedOption);
	};

	return (
		<>
			<FacialBiometricsHeader>
				<Stepper activeStep={1} />
			</FacialBiometricsHeader>
			<Stack alignItems="center" height="100%">
				<ResponsiveCard>
					<Stack alignItems="center" gap={2}>
						<IconIllustration variant="primary" customIconName="id-card" />
						<Typography variant="h6">{title}</Typography>
						<Stack
							justifyContent="flex-start"
							width="100%"
							flexDirection={isTea ? 'column-reverse' : 'column'}
							gap={2}
							mt={1}>
							{DOCUMENT_OPTIONS.filter(option =>
								isUnder16 && !isTea
									? option.value !== 'cnh'
									: option.value !== 'birthCertificate',
							).map((option, index) => (
								<RadioContainer key={index} $isError={error}>
									<Radio
										onChange={() => handleOptionChange(option.value)}
										checked={selectedOption === option.value}
										sx={{color: error ? 'error.main' : 'text.primary'}}
									/>
									<Stack>
										<Typography variant="body1" fontWeight={600}>
											{option.title}
										</Typography>
										<Typography variant="body2" color="textSecondary">
											{description}
										</Typography>
									</Stack>
								</RadioContainer>
							))}

							{error && (
								<Typography variant="caption" color="error">
									{errorMessage}
								</Typography>
							)}
						</Stack>
						{!isTablet && (
							<Stack direction="row" gap={1}>
								<Button onClick={handleNext}>{primaryButton}</Button>
							</Stack>
						)}
					</Stack>
				</ResponsiveCard>

				{isTablet ? (
					<CTAButtonFixed.Root $isTablet={isTablet} sx={{bottom: 0}}>
						<Stack direction="row" gap={2}>
							<CTAButtonFixed.Action onClick={handleNext} fullWidth>
								{primaryButton}
							</CTAButtonFixed.Action>
						</Stack>
					</CTAButtonFixed.Root>
				) : null}
			</Stack>
		</>
	);
}
